import globals from '../globals'

export default globals.settings
export const has = (key) => globals.settings[key] !== undefined
export const get = (key, defaultValue) =>
  has(key) ? globals.settings[key] : defaultValue
